import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll"
export default class extends Controller {
  static values = { target: String }

  connect() {
    if (this.targetValue) {
      // Add a small delay to ensure DOM is fully ready and layout is settled
      setTimeout(() => {
        const element = document.getElementById(this.targetValue)
        if (element) {
          // Smooth scroll to the element
          element.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      }, 100)
    }
  }
}